var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bind-container" }, [
    _vm._m(0),
    _c("div", { staticClass: "brand-section" }, [
      _c("img", {
        staticClass: "brand-logo",
        attrs: { src: "/static/anjunLogo.png", alt: "Anjun" },
      }),
      _c("div", { staticClass: "brand-slogan" }, [
        _vm._v(_vm._s(_vm.$t("login.brandSlogan"))),
      ]),
    ]),
    _c("div", { staticClass: "bind-box" }, [
      _c("div", { staticClass: "header" }, [
        _c("img", {
          staticClass: "feishu-logo",
          attrs: { src: "/static/logo/feishu-logo.png", alt: "飞书" },
        }),
        _c("h2", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("login.feishuBindTitle"))),
        ]),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("login.feishuBindSubtitle"))),
        ]),
      ]),
      _c("div", { staticClass: "form-box" }, [
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c("i", { staticClass: "el-icon-user input-icon" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.bindForm.username,
                  expression: "bindForm.username",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "input-field",
              attrs: { placeholder: _vm.$t("login.inputNumber"), type: "text" },
              domProps: { value: _vm.bindForm.username },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.handleBind($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.bindForm, "username", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c("i", { staticClass: "el-icon-lock input-icon" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.bindForm.password,
                  expression: "bindForm.password",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "input-field",
              attrs: {
                placeholder: _vm.$t("login.passwordPrompt"),
                type: "password",
              },
              domProps: { value: _vm.bindForm.password },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.handleBind($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.bindForm, "password", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]),
        ]),
        _c("div", { staticClass: "button-group" }, [
          _c(
            "button",
            {
              staticClass: "bind-button",
              attrs: { disabled: _vm.loading },
              on: { click: _vm.handleBind },
            },
            [
              _vm.loading
                ? _c("i", { staticClass: "el-icon-loading" })
                : _vm._e(),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.loading
                      ? _vm.$t("login.processing")
                      : _vm.$t("login.confirmBind")
                  )
                ),
              ]),
            ]
          ),
          _c(
            "button",
            { staticClass: "back-button", on: { click: _vm.goBack } },
            [_vm._v(" " + _vm._s(_vm.$t("login.backToLogin")) + " ")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "background-decoration" }, [
      _c("div", { staticClass: "circle circle-1" }),
      _c("div", { staticClass: "circle circle-2" }),
      _c("div", { staticClass: "circle circle-3" }),
      _c("div", { staticClass: "circle circle-4" }),
      _c("div", { staticClass: "grid-pattern" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }